/*
Author: Samir Dasarwad
Date: 09/12/2020

*/

<template>
  <div class="business">
    <div class="top-bar">
      <span @click="goToCTCSLABPage">
        <img src="@/assets/path-2-copy.png" />
      </span>
      <span class="heading_new">{{heading}}</span>
    </div>
    <toast-message
      :message="errmsg"
      type="error"
      :isToastEnable="toast"
      @close="(val) => toast = val"
    />

    <pop-up-message
      v-if="showSuccessMsg"
      :message="`${instance.slab_name} has been successfully ${editMode ? 'updated' : 'created'}`"
      btnText="Back to CTC Slab"
      @back="backfrompopup()"
    />

   

    <div class="content-new">
     

  

      <div>
        <form action class="form" v-if="instance">
          <div class="row">
            <div class="col-3 padding-l-n margin-t-l">
              <txt
                autofocus="autofocus"
                label="Name *"
                type="text"
                v-model="instance.slab_name"
                data-vv-as="name"
                name="slab_name"
                v-validate="{required: true, regex:nameField, max: nameMaxlength}"
                :classname="errors.has('slab_name')"
                :errormsg="errors.first('slab_name')"
              />
            </div>
            
          </div>
           <div class="row">
            <div class="col-3 padding-l-n margin-t-l">
              <txt
                autofocus="autofocus"
                label="FROM CTC *"
                type="number"
                v-model="instance.from_ctc"
                data-vv-as="from ctc"
                name="from_ctc"
                v-validate="{required: true, numeric: true, max:12}"
                :classname="errors.has('from_ctc')"
                :errormsg="errors.first('from_ctc')"
              />
            </div>
            
          </div>
          <div class="row">
            <div class="col-3 padding-l-n margin-t-m">
              <txt
                label="TO CTC *"
                type="number"
                v-model="instance.to_ctc"
                data-vv-as="to ctc"
                name="to_ctc"
                @blur="checkingValues()"
                v-validate="{required:true, numeric: true, max:12}"
                :classname="errors.has('to_ctc')"
                :errormsg="errors.first('to_ctc')"
              />
            </div>
          </div>
        </form>
      </div>

      <pop-up-message
        v-if="showSuccessBulkUploadMsg"
        :message="responseMsg"
        btnText="Back To ctsslab"
        @back="goToCTCSLABPage"
      ></pop-up-message>

      <bottom-action-container class="placeEnd">
        <template slot="end">
          <btn-grp>
             <btn text="Cancel" type="secondary" v-on:click="goToCTCSLABPage"></btn>
            <btn :disabled="allow" :text="submitFormText" type="primary" v-on:click="submit"></btn> 
          </btn-grp>
        </template>
      </bottom-action-container>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
import { ErrorMesages } from "../../../../../../apis/constants.js";
import * as config from "@/apis/config.js";


export default {
  data() {
    return {
       
      
      nameMaxlength: null,
      descriptionMaxlength: null,
      responseMsg: "",
      nameField: null,
      showSuccessMsg: false,
      toast: false,
      errmsg: "",
      uploadMethod: "manualUpload",
      allow: false,
      //PL-2267
      instance: {
        slab_name: "",
        from_ctc: "",
        to_ctc:""
      }
      //PL-2267
    };
  },
  computed: {
    ...mapState("onboard/ctcslab", {
      ctcSlabsDataAll: state => state.entityWiseData,
      isFetching: state => state.isFetching,
      isSaving: state => state.isSaving,
      isDeleting: state => state.isDeleting
    }),
    ...mapGetters({
      getLegalEntityId: "onboard/legal_entities/legal_entity_ID",
      record: "onboard/ctcslab/record",
      editMode: "onboard/ctcslab/editMode"
    }),
    leId() {
      if (this.$route.params.entity_index) {
        return this.getLegalEntityId(this.$route.params.entity_index);
      }
      return this.getLegalEntityId(0);
    },
    CTCslabData() {
      return this.ctcSlabsDataAll[this.leId];
    },
    isLoading() {
      return this.isFetching;
    },
    editMode() {
      return this.$store.getters["onboard/ctcslab/editMode"];
    },
    submitFormText() {
      if (this.editMode) {
        return "Update";
      } else {
        return "Add CTC Slab";
      }
    },

    heading() {
      if (this.editMode) {
         return "CTC Slab" + " - " + this.instance.slab_name;
      } else {
        
        return "Add CTC Slab";
      }
    }
  },
  activated() {
    this.toast = false;
    this.setGlobalValidations();
    //Start PL-2267
    if (this.editMode) {
      this.uploadMethod = "manualUpload";
      this.instance = this.record;
    } else {
      this.refresh();
    }
    //End PL-2267
  },
  methods: {
    ...mapActions("onboard/ctcslab/", {
      act_create: "create",
      act_update: "update",
     
    }),

    /* function to set default configuration for validation */
    setGlobalValidations(){
      try {
        this.nameField=config.Regex.ALPHA_NUM
        this.nameMaxlength = config.MaxLengthSettings.nameLength;
        this.descriptionMaxlength = config.MaxLengthSettings.descriptionLength;
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

  

    /* function to go to ctcslab main page */
    goToCTCSLABPage() {
      this.refresh();
      this.$router.push({
        path: `/onboarding/entity/${this.$route.params.entity_index}/ctcSlab`
      });
    },

    /* function to refres the page */
    refresh() {
      try {
        this.errmsg = "";
        this.toast = false;
        this.showSuccessBulkUploadMsg = false;
        this.instance = {
          slab_name: "",
          from_ctc: "",
          to_ctc: ""
        };
        this.$validator.reset();
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /* function to validate To CTC is greater than From CTC */  
    checkingValues() {
      if(this.instance.to_ctc <= this.instance.from_ctc) {
           this.toast=true
           this.errmsg="To CTC should be greater than From CTC"   
           this.allow=true
      } 
      else{
           this.toast=false
           this.allow=false
      }
    },

    /* function to hide the success pop-up and go back to Level main page */
    backfrompopup() {
      this.refresh();
      this.showSuccessMsg = false;
      this.$router.push({
        path: `/onboarding/entity/${this.$route.params.entity_index}/ctcSlab`
      });
    },

    /* function to validate from */
    submit() { 
        //console.log("eneterd to sumbiyt", this.instance)
      this.$validator.validateAll().then(result => {
        //console.log("eneterd to if", this.instance)
        if (result) {
          this.performAction();
        } else {
          this.$el
            .querySelector(
              '[data-vv-name="' + this.$validator.errors.items[0].field + '"]'
            )
            .focus();
          this.$el
            .querySelector(
              '[data-vv-name="' + this.$validator.errors.items[0].field + '"]'
            )
            .scrollIntoView({
              behavior: "smooth",
              block: "center",
              inline: "center"
            });
        }
      });
    },

    /* server call to create or update levels */
    async performAction() {
          

         //console.log("eneterd to prformaction", this.instance)
      try {
        if (!this.$_.isEmpty(this.instance.slab_name)) {
            //console.log("eneterd to if perform action", this.instance)
          this.$root._data.isSaving = true;
          let res = null;
          if (this.editMode) {
            this.instance.slab_name = this.instance.slab_name.toString().trim();
            this.instance.from_ctc = Number(this.instance.from_ctc)
            this.instance.to_ctc = Number(this.instance.to_ctc)
            
            res = await this.act_update([{ data: this.instance }, this.leId]);
          }  else {
            //console.log("eneterd to else perform action", this.instance)
            let formData = {
              slab_name: this.instance.slab_name.toString().trim(),
              from_ctc: Number(this.instance.from_ctc),
              to_ctc: Number(this.instance.to_ctc),
              le_id: this.leId
            }
            //console.log("res >>>>>>>>>>>>>> ",formData)
               res = await this.act_create({data :formData })
            //console.log("res 290 >>>>>>>>>>>>>> ",res)
            }
            //console.log("res out >>>>>>>>>>>>>> ",)
          if (res.data.status) {
            //console.log("res if >>>>>>>>>>>>>> ",)
            this.$root._data.isSaving = false;
            this.showSuccessMsg = true;
          }
        } else {
          this.toast = true;
          this.errmsg = ErrorMesages.nameError;
        }
        
      } 
      catch (err) {
        this.$root._data.isSaving = false;
        this.toast = true;
        this.errmsg = err;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
@import "@/scss/components/margins.scss";
@import "@/scss/components/form.scss";
.content-new {
  margin: 32px 0 0 32px;
  .errorr {
    border: 1px solid #e01717;
  }
  .errorMessage {
    color: #e01717;
  }
}

.business {
  display: flex;
  flex-direction: column;
  width: 100%;
}
.top-bar {
  height: 64px;
  box-shadow: 0 1px 18px 0 rgba(0, 0, 0, 0.12);
  background-color: #ffffff;
  padding: 24px 0 0 32px;
  img {
    cursor: pointer;
    margin-right: 24px;
  }
}

.heading_new {
  height: 19px;
  font-size: 16px;
  font-weight: 600;
  color: #6e6e6e;
}

.addflexispace {
  display: flex;
}
</style>
